import { Navigation } from '@sketch-note/design-system/src/shared/site-settings';

export const nothing = null;

export const authPages = [
  Navigation.Signin.href,
  Navigation.Signup.href,
  Navigation.ForgotPassword.href,
];

export const getCreationsLinkItems = (slug) => {
  return [
    {
      href: `/creations/${slug}`,
      label: 'Document',
      value: 'document',
    },
    {
      href: `/creations/${slug}/kanban`,
      label: 'Kanban',
      value: 'kanban',
    },
    {
      href: `/creations/${slug}/calendar`,
      label: 'Calendar',
      value: 'calendar',
    },
  ];
};
